module.exports = __webpack_public_path__ + "static/media/carousel_en_fintec.14e350f9.jpg";